<template>
	<div class="claim-title" :style="isClose ? 'justify-content: space-between':''">
		<div v-if="!isClose" class="back-text claim-title" @click="$emit('back')">
			<v-icon small color="#00AAFD" class="mr-1">mdi-arrow-left</v-icon>
			<span style="margin-top: 1px;">
				<span v-if="$vuetify.breakpoint.smAndUp">{{ text }}</span>
				<span v-else>Back</span>
			</span>
		</div>
		<div class="ml-3 claim-title-text">{{ title }}</div>
		<v-icon  v-if="isClose" @click="$emit('back')">mdi-close</v-icon>
	</div>
</template>
<script>
export default {
	name: 'ApprovalClaimTitle',
	props: {
		title: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			default: ''
		},
		isClose: {
			type: Boolean,
			default: false
		}
	}
}
</script>
<style lang="scss" scoped>
.claim-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
}
.back-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  color: #00AAFD;
  &:hover {
    cursor: pointer;
  }
}
.claim-title-text {
	font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
	color: 	#192A3E;
}

.back-text-underline {
  text-decoration: underline;
}
</style>